import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import { Link } from 'react-router-dom';
import { FaCalendar, FaUser } from 'react-icons/fa';

function LatestAutomations() {
  const [automations, setAutomations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLatestAutomations = async () => {
      try {
        const q = query(
          collection(db, 'automations'),
          orderBy('createdAt', 'desc'),
          limit(3)
        );
        
        const querySnapshot = await getDocs(q);
        const automationsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setAutomations(automationsData);
      } catch (error) {
        console.error('Otomasyonlar yüklenirken hata:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLatestAutomations();
  }, []);

  if (loading) {
    return (
      <div className="animate-pulse space-y-4">
        {[1, 2, 3].map((item) => (
          <div key={item} className="h-24 bg-gray-200 rounded"></div>
        ))}
      </div>
    );
  }

  return (
    <div className="h-full">
      <h2 className="text-2xl font-bold mb-6 text-gray-800 flex items-center">
        <span className="bg-gradient-to-r from-emerald-500 to-green-600 text-transparent bg-clip-text">Son Otomasyonlar</span>
      </h2>
      
      <div className="space-y-4">
        {automations.map((automation) => (
          <Link
            key={automation.id}
            to={`/automation/${automation.id}`}
            className="group block hover:bg-white rounded-xl p-4 transition-all duration-300 border border-emerald-100/50 hover:border-emerald-200 hover:shadow-lg relative overflow-hidden"
          >
            <div className="absolute inset-0 bg-gradient-to-r from-emerald-50 to-blue-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            <div className="relative flex items-start space-x-4">
              {automation.coverImage ? (
                <img 
                  src={automation.coverImage} 
                  alt={automation.title}
                  className="w-20 h-20 object-cover rounded-lg shadow-md group-hover:shadow-lg transition-all duration-300"
                />
              ) : (
                <div className="w-20 h-20 bg-gradient-to-br from-emerald-400 to-blue-400 rounded-lg shadow-md group-hover:shadow-lg transition-all duration-300 flex items-center justify-center">
                  <span className="text-2xl font-bold text-white">{automation.title.charAt(0)}</span>
                </div>
              )}
              
              <div className="flex-1 min-w-0">
                <div className="flex justify-between items-start">
                  <h3 className="font-semibold text-base text-gray-800 mb-1 truncate group-hover:text-emerald-600 transition-colors duration-300">
                    {automation.title}
                  </h3>
                  {automation.price && (
                    <span className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-xs font-medium ml-2 whitespace-nowrap shadow-sm group-hover:shadow transition-all duration-300">
                      {typeof automation.price === 'number' 
                        ? `${automation.price.toLocaleString('tr-TR')} ₺` 
                        : automation.price}
                    </span>
                  )}
                </div>
                
                <div className="flex items-center text-xs text-gray-500 space-x-3 mb-2">
                  <span className="flex items-center">
                    <FaCalendar className="mr-1 text-emerald-500" />
                    {new Date(automation.createdAt?.toDate()).toLocaleDateString('tr-TR')}
                  </span>
                  
                  <span className="flex items-center">
                    <FaUser className="mr-1 text-emerald-500" />
                    {automation.author}
                  </span>
                </div>

                {automation.tags && (
                  <div className="flex flex-wrap gap-1">
                    {automation.tags.slice(0, 3).map((tag, index) => (
                      <span
                        key={index}
                        className="px-2 py-0.5 bg-emerald-50 text-emerald-600 rounded-lg text-xs font-medium border border-emerald-100 group-hover:border-emerald-200 transition-colors duration-300"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-6 text-center">
        <Link
          to="/automation"
          className="inline-flex items-center px-4 py-2 bg-gradient-to-r from-emerald-500 to-green-600 text-white rounded-lg hover:from-emerald-600 hover:to-green-700 transition-all duration-200 text-sm font-medium"
        >
          Tüm Otomasyonlar
          <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </Link>
      </div>
    </div>
  );
}

export default LatestAutomations; 